import { ReactNode, useEffect, useMemo } from 'react'
import {
  initialQueryState,
  OptionsHelper,
  useDebounce,
} from '../../../../../../../_metronic/helpers'
import { useQueryRequest } from '../../core/QueryRequestProvider'
import { useListFilters } from '../../core/ListFiltersProvider'
import { useQueryResponse } from '../../core/QueryResponseProvider'
import {
  ActiveFilter,
  ActiveFiltersBar,
  CustomSelect,
  Input,
  IOption,
  TableFilter,
  TableFilters,
} from '../../../../../../components'
import { useT } from '../../../../../../../_metronic/i18n/Metronici18n'

type Props = {
  /** Conteúdo à direita da linha dos campos (ex.: barra de seleção em lote). */
  actions?: ReactNode
}

export const EmpresasListSearchComponent = ({ actions }: Props) => {
  const { updateState } = useQueryRequest()
  const { response, isLoading } = useQueryResponse()
  const { filters, setFilter, clearFilters } = useListFilters()
  const { t } = useT()
  const total = response?.totalElements ?? 0

  const debouncedFilters = useDebounce(filters, 500)

  const search = useMemo(() => {
    return [
      debouncedFilters.status ? `ativa:${debouncedFilters.status.value}` : '',
      debouncedFilters.empresa ? `nome~*${debouncedFilters.empresa}*` : '',
    ]
      .filter(Boolean)
      .join(',')
  }, [debouncedFilters])

  useEffect(() => {
    updateState({
      search,
      ...initialQueryState,
    })
  }, [search, updateState])

  // Chips da faixa "Filtros ativos": cada × limpa só o seu campo.
  const activeFilters: ActiveFilter[] = [
    filters.empresa && {
      key: 'empresa',
      label: 'Instituição',
      value: `“${filters.empresa}”`,
      onRemove: () => setFilter('empresa', ''),
    },
    filters.status && {
      key: 'status',
      label: 'Status',
      value: filters.status.label,
      onRemove: () => setFilter('status', undefined),
    },
  ].filter((filter): filter is ActiveFilter => Boolean(filter))

  return (
    <TableFilters
      actions={actions}
      footer={
        <ActiveFiltersBar
          filters={activeFilters}
          onClearAll={clearFilters}
          summary={
            isLoading
              ? 'Buscando…'
              : `${total} ${total === 1 ? 'instituição encontrada' : 'instituições encontradas'}`
          }
        />
      }
    >
      <TableFilter label={t('empresa.label')} wide>
        <Input
          entity='empresa'
          value={filters.empresa}
          onChange={(e) => setFilter('empresa', e.target.value)}
        />
      </TableFilter>
      <TableFilter label={t('situacao.label')}>
        <CustomSelect
          entity='situacao'
          onChange={(status?: IOption<boolean>) => setFilter('status', status ?? undefined)}
          options={OptionsHelper.statusCadastro}
          value={filters.status}
        />
      </TableFilter>
    </TableFilters>
  )
}
